import { create } from "zustand";

export interface ModalStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useLoginModal = create<ModalStore>((set) => ({
  open: false,
  setOpen(open) {
    set({ open });
  },
}));

export const useCalculatorModal = create<ModalStore>((set) => ({
  open: false,
  setOpen(open) {
    set({ open });
  },
}));

export const useCartModal = create<ModalStore>((set) => ({
  open: false,
  setOpen(open) {
    set({ open });
  },
}));
